import { useEffect, useState } from "react";
import { BRAND } from "../content/site";

const KEY = "camilla_age_ok";

export default function AgeGate() {
  const [ok, setOk] = useState(true); // start true so nothing flashes; check in effect

  useEffect(() => {
    const stored = typeof window !== "undefined" && window.localStorage.getItem(KEY);
    setOk(stored === "1");
  }, []);

  if (ok) return null;

  const confirm = () => {
    window.localStorage.setItem(KEY, "1");
    setOk(true);
  };
  const exit = () => {
    window.location.href = "https://www.google.com/";
  };

  return (
    <div className="age-gate" data-testid="age-gate">
      <div className="max-w-xl w-full text-center">
        <div className="eyebrow justify-center mx-auto mb-6" data-testid="age-gate-eyebrow">
          Adults Only · 18+
        </div>
        <h1
          className="font-display text-5xl md:text-6xl text-gold mb-6"
          style={{ letterSpacing: "0.02em" }}
        >
          {BRAND.siteTitle}
        </h1>
        <div className="hairline my-6 mx-auto max-w-xs" />
        <p className="text-ivory-dim leading-relaxed text-base md:text-lg mb-3">
          This website contains adult content intended for persons{" "}
          <span className="text-gold">18 years or older</span>. By entering, you
          confirm you are of legal age in your jurisdiction and consent to
          viewing adult material.
        </p>
        <p className="text-xs md:text-sm text-[color:var(--muted)] mb-10 leading-relaxed">
          Camilla is an independent, legal private service provider based in NSW,
          Australia, where sex work is decriminalised.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 items-center justify-center">
          <button
            className="btn-gold w-full sm:w-auto"
            onClick={confirm}
            data-testid="age-gate-enter-btn"
          >
            I am 18+ — Enter
          </button>
          <button
            className="btn-ghost-gold w-full sm:w-auto"
            onClick={exit}
            data-testid="age-gate-exit-btn"
          >
            Exit
          </button>
        </div>
      </div>
    </div>
  );
}
